import { Icon } from '@design-system/icon';
import clsx from 'classnames';
import React from 'react';

import { useBrowserScreen } from '~/components/ExtendedGlobalHeader/hooks/useBrowserScreen';
import { useTranslations } from '~/context/TranslationContext/TranslationsContext';

export type FeaturedEventProps = {
  heading: string;
  linkLabel: string;
  title: string;
  description: string;
  url: string;
  imgSrc: string;
  imgAlt?: string;
  className?: string;
  isDivider?: boolean;
};
const FeaturedEvent: React.FC<FeaturedEventProps> = ({
  heading = 'Featured Event',
  linkLabel,
  description,
  title = '',
  imgSrc,
  url,
  imgAlt = '',
  className = '',
  isDivider = false,
}) => {
  const t = useTranslations();
  const { isMobileView } = useBrowserScreen();

  return (
    <div
      className={clsx('fe-card', className, {
        'fe-card--isMobile': isMobileView,
        'fe-card--with-divider': isDivider && !isMobileView,
      })}
    >
      <div className="fe-card__heading">{heading}</div>

      <div className="fe-card__row">
        <div className="fe-card__media">
          <img className="fe-card__img" src={imgSrc} alt={imgAlt} />
        </div>

        <div className="fe-card__content">
          <h3 className="fe-card__title">{title}</h3>
          <p className="fe-card__description">{description}</p>

          <a className="fe-card__cta" href={url} aria-label={linkLabel}>
            <span className="fe-card__ctaIcon" aria-hidden="true">
              <Icon size={15} icon="arrowRight" />
            </span>
            <span className="fe-card__ctaLabel">
              {t?.card?.learnMoreButton}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FeaturedEvent;
